import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useGetQueryParam } from '../../../app/hooks/useGetQueryParam';
import { useSetQueryParams } from '../../../app/hooks/useSetQueryParams';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FavoriteFilter() {
  const isFavorite = useGetQueryParam('isFavorite');
  const setQueryParams = useSetQueryParams();
  const handleChange = () => {
    setQueryParams({
      isFavorite: isFavorite === 'true' ? '' : 'true',
      offset: ''
    });
  };
  return /*#__PURE__*/_jsx(Checkbox, {
    checked: isFavorite === 'true',
    onChange: handleChange,
    alignment: "start",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.filters.isFavorite.label"
    })
  });
}